export default __webpack_public_path__ + "static/media/brachot-hanenim-mission.88d82fc0.png";